import React from 'react';
import { IconFileDescription, IconDeviceMobileCheck, IconTrophy } from '@tabler/icons-react';
import { Col, Row } from 'reactstrap';
import moment from 'moment';

import { usePhases } from '../../../store/configStore';
import { useCampaignFlowConfig } from '../../../store/designStore';
import ResponsiveImageSet from '../ResponsiveImageSet/ResponsiveImageSet';

const CampaignFlow = ({ style = {} }) => {
    const phases = usePhases();
    const { type, breakpoints, altText: campaignFlowAltText } = useCampaignFlowConfig();
    const altText = campaignFlowAltText !== undefined && campaignFlowAltText !== null ? campaignFlowAltText : '';

    const hasQualification = phases.hasQualification;
    const hasFinale = phases.hasFinale;

    const activeSteps = 1 + (hasQualification ? 1 : 0) + (hasFinale ? 1 : 0);
    const colWidth = activeSteps === 3 ? '4' : activeSteps === 2 ? '6' : '12';

    const shortenDate = (from, until) => {
        if (until) {
            return moment(from).format('DD.MM.') + ' - ' + moment(until).format('DD.MM.');
        }
        return moment(from).format('DD.MM.');
    };

    if (type === 'graphic' && breakpoints && breakpoints.length > 0) {
        return <ResponsiveImageSet breakpoints={breakpoints} altText={altText} style={style} />;
    }

    return (
        <Row style={style}>
            <Col xs="12" lg={colWidth} className="my-2">
                <Row>
                    <Col xs="4" lg="12" className="d-flex align-items-center mb-2">
                        <IconFileDescription size={48} className="w-100 text-primary" />
                    </Col>
                    <Col xs="7" lg="12" className="d-flex align-items-center">
                        <h3 className="text-primary text-left text-lg-center m-0 w-100">
                            Bewerbung:
                            <br />
                            ab sofort
                        </h3>
                    </Col>
                </Row>
            </Col>
            {hasQualification && (
                <Col xs="12" lg={colWidth} className="my-2">
                    <Row>
                        <Col xs="4" lg="12" className="d-flex align-items-center mb-2">
                            <IconDeviceMobileCheck size={48} className="w-100 text-primary" />
                        </Col>
                        <Col xs="7" lg="12" className="d-flex align-items-center">
                            <h3 className="text-primary text-left text-lg-center m-0 w-100">
                                Qualifikation:
                                <br />
                                {shortenDate(phases.voteStart, phases.voteStartFinale)}
                            </h3>
                        </Col>
                    </Row>
                </Col>
            )}
            {hasFinale && (
                <Col xs="12" lg={colWidth} className="my-2">
                    <Row>
                        <Col xs="4" lg="12" className="d-flex align-items-center mb-2">
                            <IconTrophy size={48} className="w-100 text-primary" />
                        </Col>
                        <Col xs="7" lg="12" className="d-flex align-items-center">
                            <h3 className="text-primary text-left text-lg-center m-0 w-100">
                                {hasQualification ? 'Finale:' : 'Abstimmung:'}
                                <br />
                                {shortenDate(phases.voteStartFinale, phases.voteEnd)}
                            </h3>
                        </Col>
                    </Row>
                </Col>
            )}
        </Row>
    );
};

export default CampaignFlow;
